// extracted by mini-css-extract-plugin
module.exports = {"Container":"MultiColumnLayoutContainer_Container__3L9Ld"};